import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const initialisation = (state: RootState) => state.initialisation;

export const startingSelections = createSelector(initialisation, state =>
    state.state === 'configuration' ? state.startWithSelections : null,
);

export const currentInspirationProductId = createSelector(initialisation, state =>
    state.state === 'inspiration' ? state.productId : undefined,
);

export const launchInspirationProductId = createSelector(initialisation, state =>
    state.state === 'inspiration' ? state.launchProductId : undefined,
);

export const inInspiration = createSelector(initialisation, state => state.state === 'inspiration');

export const inConfiguration = createSelector(
    initialisation,
    state => state.state === 'configuration',
);

/** null means there are none, undefined means we're not in inspiration nor configuration */
export const configurableProperties = createSelector(initialisation, inConfiguration, state => {
    return state.state === 'configuration' ? state.configurableProperties : undefined;
});

export const currentConfiguratorDefinition = createSelector(initialisation, state =>
    state.state === 'configuration' ? state.configuratorDefinition : undefined,
);

export const modularSelections = createSelector(initialisation, state =>
    state.state === 'modular' ? state.startWithSelections : undefined,
);

export const configurationStartingProduct = createSelector(initialisation, state =>
    state.state === 'configuration' && state.startingProduct ? state.startingProduct : undefined,
);

export const configurationStartingProductId = createSelector(initialisation, state =>
    state.state === 'configuration' && state.startingProduct
        ? state.startingProduct.productId
        : undefined,
);

export const configurationStartingProductGroupingCode = createSelector(initialisation, state =>
    state.state === 'configuration' ? state.startingGroupingCode : undefined,
);

export const shouldShowArModal = createSelector(initialisation, state =>
    state.state === 'inspiration' ||
    state.state === 'configuration' ||
    state.state === 'modular'
        ? state.shouldOpenArModal
        : false,
);

export const shouldDisplayUnpublished = createSelector(initialisation, state =>
    state.state === 'inspiration' ||
    state.state === 'configuration'
        ? state.shouldDisplayUnpublished
        : false,
);
